export default {
  extraProfile: {
    myRegisterPersons: "v1/fa/extra-profile/my-register-person",
    myRegisterPerson: "v1/fa/extra-profile/my-register-person/{0}",
    myRegisterPersonTags: "v1/fa/extra-profile/my-register-person/{0}/tags",
  },
};
